import { useState, useCallback } from 'react';

interface PageLoaderState {
  isLoading: boolean;
  message: string;
}

export const usePageLoader = () => {
  const [loaderState, setLoaderState] = useState<PageLoaderState>({
    isLoading: false,
    message: 'Loading...'
  });

  const showLoader = useCallback((message: string = 'Loading...') => {
    setLoaderState({
      isLoading: true,
      message
    });
  }, []);

  const hideLoader = useCallback(() => {
    setLoaderState(prev => ({
      ...prev,
      isLoading: false
    }));
  }, []);

  const setLoaderMessage = useCallback((message: string) => {
    setLoaderState(prev => ({
      ...prev,
      message
    }));
  }, []);

  return {
    isLoading: loaderState.isLoading,
    message: loaderState.message,
    showLoader,
    hideLoader,
    setLoaderMessage
  };
};
